<template>
    <div>
        <div class="bio-selection">
            <!--
            <div class="bio" :class="{ 'font-italic' : isOnboarding }">
                <span v-html="bioFormatted"></span>
            </div>
            -->

            <div v-if="edit">
                <b-alert variant="success" :show="showSuccess" class="mb-3 mt-0 mx-0">
                    Your bio has been saved.
                </b-alert>
                <b-alert variant="danger" :show="showError" class="mb-3 mt-0 mx-0">
                    <ul class="mb-0">
                        <li v-for="(error, prop) in errors" :key="prop">
                            {{ error[0] }}
                        </li>
                    </ul>
                </b-alert>
                
                <b-form-textarea
                    v-model="bio"
                    placeholder="Choose your bio..."
                    :disabled="!isReady"
                    height="75"
                    @keyup="remainCharCount"
                    ></b-form-textarea>
                <p>
                    <span class="form-text text-muted mb-2" v-html="remainCharactersText"></span>
                </p>
                <button type="button" class="btn btn-success" @click="save" :disabled="isBusy">{{ btnText }}</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            edit: {
                type: Boolean,
                required: false,
            },
            isOnboarding: {
                type: Boolean,
                required: false,
                default: false,
            },
        },

        data() {
            return {
                bio: '',
                bioFormatted: '',
                isBusy: false,
                showSuccess: false,
                showError: false,
                errors: '',
                btnText: 'Save',
                isReady: false,
                maxChars: 160,
                remainCharactersText: '',
            }
        },

        mounted() {
            this.getBio();
        },

        methods: {
            remainCharCount() {
                if(this.bio.length > this.maxChars) {
                    this.remainCharactersText = "<small style='color: red;'>Exceeded " + this.maxChars + " characters limit.</small>";
                } else {
                    var remainCharacters = this.maxChars - this.bio.length;
                    this.remainCharactersText = "<small style='color: green;'>Remaining " + remainCharacters + " characters.</small>";
                } 
            },

            // Upload
            save() {
                this.isBusy = true;
                this.errors = null;
                this.showError = false;
                this.btnText = 'Please wait...';
                this.showSuccess = false;

                axios.post('/api/me/update-bio', {
                    bio: this.bio,
                }).then((response) => {
                    this.reset();

                    Bus.$emit('bioUpdated', {
                        'bio': this.bio,
                    });

                    this.bioFormatted = response.data.bioFormatted;

                    this.showSuccess = true;
                }).catch((e) => {
                    this.showError = true;
                    this.errors = e.response.data.errors;
                    this.reset();
                });
            },

            // Reset form
            reset() {
                this.isBusy = false;
                this.btnText = 'Save';
            },

            // Get current bio
            getBio() {
                axios.get('/api/me/get-bio').then((response) => {
                    this.bio = response.data.bio ?? '';
                    this.bioFormatted = response.data.bioFormatted;
                    this.isReady = true;
                    this.remainCharCount();
                });
            }
        }
    }
</script>